var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 22.0667H22.2667V14.0667H23.6V11.4L22.2667 4.73334H2.26671L0.93338 11.4V14.0667H2.26671V22.0667H14.2667V14.0667H19.6V22.0667ZM11.6 19.4H4.93338V14.0667H11.6V19.4ZM2.26671 0.733337H22.2667V3.4H2.26671V0.733337Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd1);
export default __webpack_public_path__ + "static/media/dd-1.2cf0c0304d1548aaa097680cfcb8d126.svg";
export { ForwardRef as ReactComponent };